import FeatureFlags from 'garaje/services/feature-flags';

export default FeatureFlags.extend({
  trafficType: 'location',
});
